'use strict';

var ActivationController = require('components/activation/activation_controller');
var App = require('app');
var AppState = require('app_state');
var Cookie = require('utils/cookie');
var HelpViews = require('components/help/views/views');
var i18n = require('utils/i18n');
var Log = require('utils/log');
var LoginView = require('components/account/views/login_view');
var MFAView = require('components/account/views/mfa_view');
var Notification = require('utils/notification');
var PasswordResetView = require('components/account/views/password_reset_view');
var SignupView = require('components/account/views/signup_view');
var SignupCompanyView = require('components/account/views/signup_company_view');
var SetPasswordView = require('components/activation/views/password_reset_view');
var utils = require('components/common/utils');

var AccountController = {};

AccountController.showLogin = function (contextData, errors) {
    var loggedIn = AppState.user !== undefined;
    if (loggedIn) App.trigger('home:show');

    var view = new LoginView({ controller: this, contextData: contextData, errors: errors });
    App.main.show(view);
};

AccountController.showMFA = function (user, loginFormData) {
    var view = new MFAView({
        controller: this,
        user: user,
        formData: loginFormData,
    });
    App.main.show(view);
};

AccountController.showPasswordReset = function () {
    var view = new PasswordResetView({ controller: this });
    App.main.show(view);
};

AccountController.showSignup = function (refActivation) {
    var self = this;
    var reqEmail = null;
    if (refActivation) {
        // request the email
        var d = $.Deferred();
        App.ajax({
            url: '/api/v1/account/activate/email',
            method: 'GET',
            data: {
                type: refActivation.type,
                token: refActivation.token,
            },
            success: function (result) {
                d.resolve(result);
            },
            error: function (result) {
                d.resolve('');
            },
        });

        reqEmail = d.promise();
    }

    $.when(reqEmail).done(function (email) {
        var view = new SignupView({ controller: self, refActivation: refActivation, email: email });
        App.main.show(view);
    });
};

AccountController.showSignupCompany = function () {
    var view = new SignupCompanyView({ controller: this });
    App.main.show(view);
};

AccountController.showTermsDialog = function (is_signup) {
    var termsFetched = $.get('/lang/' + i18n.language + '_terms.html');
    $.when(termsFetched)
        .done(function (terms) {
            var view = new HelpViews.TermsDialog({
                title: i18n.TR('Nutzungsbedingungen'),
                content: terms,
                isSignup: is_signup,
                action_cb: function () {
                    $('#js-register-terms-input').prop('checked', true);
                },
            });
            App.showModal(view);
        })
        .fail(function () {
            Notification.show('error', i18n.TR('Fehler'), i18n.TR('Nutzungsbedingungen konnten nicht geladen werden.'));
        });
};

AccountController.showGdprDialog = function (is_signup) {
    var termsFetched = $.get('/lang/' + i18n.language + '_gdpr.html');
    $.when(termsFetched)
        .done(function (terms) {
            var view = new HelpViews.TermsDialog({
                title: i18n.TR('Datenschutzhinweis'),
                content: terms,
                isSignup: is_signup,
                action_cb: function () {
                    $('#js-register-gdpr-input').prop('checked', true);
                },
            });
            App.showModal(view);
        })
        .fail(function () {
            Notification.show('error', i18n.TR('Fehler'), i18n.TR('Datenschutzhinweis konnte nicht geladen werden.'));
        });
};

AccountController.showImprint = function () {
    App.main.show(new HelpViews.ImprintFullScreen());
};

AccountController.authenticate = function (formData) {
    var self = this;
    utils.showLoadingHint(i18n.TR('Anmeldung'));

    $.when(App.fingerprintComputation).done(function () {
        App.ajax({
            url: '/api/v1/account/login',
            type: 'POST',
            data: {
                email: formData.username,
                password: formData.password,
                remember_me: formData.remember_me,
                activation_type: formData.activationType,
                activation_token: formData.activationToken,
                fingerprint: App.browserFingerprint,
                code: formData.code,
            },
            success: function (data) {
                if (data.mfa) {
                    if (!data.mfa_active) {
                        var ProfileController = require('components/profile/profile_controller');
                        ProfileController.showMFAconfigurationDialog(true);
                        return;
                    }
                    AccountController.showMFA(data, formData);
                    return;
                }
                if (formData.activationType && formData.activationToken && !data.mfa) {
                    ActivationController.processActivation(formData.activationType, formData.activationToken, {});
                    return;
                }

                var user = App.request('user:me');
                $.when(user).done(function (user) {
                    if (user.attributes.config != undefined) {
                        var prefs = (user.attributes.config.info || {}).preferences || {};
                        var frontendVersion = prefs.frontend_version || 'classic';
                        if (frontendVersion != 'classic') {
                            window.location = 'v2/';
                            return;
                        }
                    }
                    AccountController.startSession();
                });
            },
            error: function (xhr) {
                var errors = xhr.responseJSON || { error: xhr.responseText.trim() };
                var view = new LoginView({ controller: self, errors: errors, formData: formData });

                if (errors.error != undefined) {
                    if (errors.error.startsWith('token:')) {
                        // HACK: error-message contains the token + the prefix "token:".
                        //       -> [MS] It should be possible to pass the token directly as JSON.
                        var token = errors.error.slice(6);
                        errors.error = i18n.TR(
                            'Ihr Konto wurde gesperrt, da Ihr Passwort abgelaufen ist. Bitte vergeben Sie jetzt ein Neues.'
                        );
                        view = new SetPasswordView({ controller: ActivationController, errors: errors, token: token });
                    }
                    switch (errors.error) {
                        case 'locked':
                            errors.error = i18n.TR('Ihr Konto wurde gesperrt.');
                            break;
                        case 'too_many_attempts':
                            errors.error = i18n.TR('Ihr Konto wurde gesperrt.');
                            break;
                        case 'locked_notified':
                            errors.error = i18n.TR(
                                'Ihr Konto wurde gesperrt. Sie erhalten eine E-Mail mit einem Link, mit dem Sie Ihr Passwort zurücksetzen können.'
                            );
                            break;
                        case 'unknown_user':
                            errors.error = i18n.TR('Unbekannter Nutzer oder falsches Passwort.');
                            break;
                    }

                    if (errors.error === 'mfa_invalid') {
                        errors.error = i18n.TR('Zahlencode ungültig.');
                        view = new MFAView({
                            controller: self,
                            errors: errors,
                            user: { email: formData.username },
                            formData: formData,
                        });
                    }
                }
                App.main.show(view);
            },
        });
    });
};

AccountController.startSession = function () {
    // reset cache
    App.initializeAppStateCache(true);
    if (AppState.lastLocation) {
        window.location.assign(AppState.lastLocation);
        window.location.reload();
        return;
    }
    App.trigger('home:show');
};

AccountController.logout = function () {
    App.ajax({
        url: '/api/v1/account/logout',
        type: 'POST',
        data: {},
        success: function () {
            Cookie.delete('initialized');
            App.trigger('login:show');
        },
    });
};

AccountController.signup = function (formData, refActivation) {
    var self = this;
    if (!refActivation) refActivation = {};

    utils.showLoadingHint(i18n.TR('Registrierung'));
    App.ajax({
        url: '/api/v1/account/signup',
        type: 'POST',
        data: {
            username: formData['register-username'],
            email: formData['register-email'],
            password: formData['register-password'],
            accept_terms: formData['register-terms'],
            token: refActivation.token,
            type: refActivation.type,
        },
        success: function () {
            if (refActivation.token && refActivation.type) {
                App.trigger('activation:show', refActivation.type, refActivation.token);
            } else {
                utils.showHint({
                    title: i18n.TR('Registrierung erfolgreich'),
                    hint: i18n.TR('Sie erhalten in Kürze eine E-Mail.'),
                    hintClass: 'success',
                    hintID: 'registration',
                });
            }
        },
        error: function (xhr) {
            var errors = xhr.responseJSON || { error: xhr.responseText };
            // deleting password-information from formData
            formData['register-password'] = '';
            var view = new SignupView({
                controller: self,
                errors: errors,
                formData: formData,
                refActivation: refActivation,
            });
            App.main.show(view);
        },
    });
};

AccountController.signupCompany = function (formData) {
    var self = this;
    utils.showLoadingHint(i18n.TR('Registrierung'));
    App.ajax({
        url: '/api/v1/account/signup-company',
        type: 'POST',
        data: {
            companyname: formData['register-companyname'],
            subdomain: formData['register-subdomain'],
            username: formData['register-username'],
            email: formData['register-email'],
            password: formData['register-password'],
            accept_terms: formData['register-terms'],
        },
        success: function () {
            utils.showHint({
                title: i18n.TR('Registrierung erfolgreich'),
                hint: i18n.TR('Sie erhalten in Kürze eine E-Mail.'),
                hintClass: 'success',
                hintID: 'registration',
            });
        },
        error: function (xhr) {
            var errors = xhr.responseJSON || { error: xhr.responseText };
            // deleting password-information from formData
            formData['register-password'] = '';
            var view = new SignupCompanyView({ controller: self, errors: errors, formData: formData });
            App.main.show(view);
        },
    });
};

AccountController.passwordReset = function (formData) {
    var self = this;
    utils.showLoadingHint(i18n.TR('Passwort-Reset Link anfordern'));
    App.ajax({
        url: '/api/v1/account/password-reset',
        type: 'POST',
        data: {
            email: formData['email'],
        },
        success: function () {
            utils.showHint({
                title: i18n.TR('Passwort-Reset Link angefordert'),
                hint: i18n.TR('Sie erhalten in Kürze eine E-Mail.'),
                hintClass: 'success',
                hintID: 'pw-reset',
            });
        },
        error: function (xhr) {
            var errors = xhr.responseJSON || { error: xhr.responseText };
            var view = new PasswordResetView({ controller: self, errors: errors, formData: formData });
            App.main.show(view);
        },
    });
};

module.exports = AccountController;
